/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { store as sarsaparillaStore, sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth';

const rootReducer = combineReducers({
    ...sarsaparillaReducers,
    ...authReducers,
});

const initialState = {
    ...sarsaparillaStore(),
};

export function setupStore(preloadedState?: any) {
    const store = configureStore({
        preloadedState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: ['launchdarkly'],
                },
            });
        },
        devTools: process.env.DEV_TOOLS_ENABLED,
    });

    return store;
}

const store = setupStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

export default store;
